<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Area Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <GChart
              class="google-chart"
              type="AreaChart"
              :data="ChartOptions.areachart.chartData"
              :options="ChartOptions.areachart.chartOption"
              style="width: 100%; height: 500px"
            />
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Bar Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <GChart
              class="google-chart"
              type="BarChart"
              :data="ChartOptions.barchart.chartData"
              :options="ChartOptions.barchart.chartOption"
              style="width: 100%; height: 500px"
            />
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Bubble Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <GChart
              class="google-chart"
              type="BubbleChart"
              :data="ChartOptions.bubblechart.chartData"
              :options="ChartOptions.bubblechart.chartOption"
              style="width: 100%; height: 500px"
            />
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Line Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <GChart
              class="google-chart"
              type="LineChart"
              :data="ChartOptions.linechart.chartData"
              :options="ChartOptions.linechart.chartOption"
              style="width: 100%; height: 500px"
            />
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { GChart } from "vue-google-charts";
import GoogleChart from "@/demo-data/Chart/Googlechart.js";

export default {
  components: {
    GChart,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      ChartOptions: GoogleChart[0],
    };
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/styles/components/googlechart.scss";
</style>